<template>
    <EvieRenameConversationModal
        :current-title="currentTitle"
        :saving="saving"
        :error="error"
        @submit="onSubmit"
        @close="$emit('abort')"
    />
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { useEvieAiStore } from '@/modules/evie-ai/store';

    import EvieRenameConversationModal from '../components/EvieRenameConversationModal/EvieRenameConversationModal.vue';

    // PRODUCT-26110 QA fixes4: declares every event this procedure component `$emit`s --
    // without a declared `emits`, Vue 3 warns "Component emitted event 'abort'/'finish'
    // but it is neither declared in the emits option nor as an 'onAbort'/'onFinish' prop"
    // every time it fires.
    export default defineComponent({
        name: 'EvieRenameConversationProcedure',
        components: { EvieRenameConversationModal },
        props: {
            // PRODUCT-26110 QA fixes4: `uuid` is unused; declared purely so Vue 3 doesn't
            // warn "Extraneous non-props attributes (uuid)" (see
            // UploadEntityDocumentProcedure.vue).
            uuid: { type: String, default: '' },
            rpName: { type: String, required: true },
            conversationId: { type: String, required: true },
            currentTitle: { type: String, required: true },
        },
        emits: [ 'abort', 'finish' ],
        data() {
            return {
                saving: false as boolean,
                error: '' as string,
            };
        },
        methods: {
            async onSubmit(title: string) {
                this.saving = true;
                this.error = '';
                try {
                    await (this as any).$gatewayClient.tprmUi()
                        .renameEvieConversation(this.rpName, this.conversationId, title);
                    useEvieAiStore().applyConversationTitleUpdate({
                        conversationId: this.conversationId,
                        title,
                    });
                    this.$emit('finish');
                } catch {
                    this.error = 'Failed to rename. Please try again.';
                } finally {
                    this.saving = false;
                }
            },
        },
    });
</script>
